import { styled, Box } from "@mui/material";
import { colors } from "../../../../theme/colors";

export const MainEditInterviewContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  overflowY: "hidden",
  height: "calc(100vh - 85px)",
  backgroundColor: "#f8fafc",
  borderRadius: "16px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.04)",
  border: `1px solid ${colors.border.light}`,
  margin: "0 16px 16px 16px",
  overflow: "hidden",
}));

